import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { playSound, SOUNDS } from '../App';

export default function ContextMenu({ x, y, items, onClose }) {
  const handleClick = (action) => {
    playSound(SOUNDS.click);
    action();
    onClose();
  };

  return (
    <>
      <div className="context-menu-backdrop" onClick={onClose} />
      <motion.div
        className="context-menu"
        style={{ left: x, top: y }}
        initial={{ opacity: 0, scale: 0.92, y: -5 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: -5 }}
        transition={{ duration: 0.12, ease: [0.25, 0.46, 0.45, 0.94] }}
      >
        {items.map((item, i) => (
          item.divider ? (
            <div key={i} className="context-menu-divider" />
          ) : (
            <motion.button
              key={i}
              className={`context-menu-item ${item.disabled ? 'disabled' : ''}`}
              onClick={() => !item.disabled && handleClick(item.action)}
              disabled={item.disabled}
              initial={{ opacity: 0, x: -5 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.02, duration: 0.1 }}
              whileHover={{ backgroundColor: '#000080', color: 'white' }}
            >
              {item.icon && <span className="context-menu-icon">{item.icon}</span>}
              <span>{item.label}</span>
              {item.shortcut && <span className="context-menu-shortcut">{item.shortcut}</span>}
            </motion.button>
          )
        ))}
      </motion.div>
    </>
  );
}
